import { PHONE_LINK, PHONE_NUMBER } from "./contactUs";

export const premiumLastPlanMessage = (number, itemText) => {
  return `در نرم‌افزار تنخواه‌گردان شما می‌توانید حداکثر ${
    number ? number + " " : ""
  }${itemText} کنید.
    <br/>
    در صورت درخواست بیشتر از این مقدار با واحد پشتیبانی تماس بگیرید.
    <br/>
    <a href=${PHONE_LINK}>شماره تماس: ${PHONE_NUMBER}</a>
    `;
};

export const premiumFiniteUpgradePLanByOwnerMessage = (
  number,
  itemText1,
  itemText2
) => {
  return `در طرح فعلی شما می‌توانید حداکثر ${
    number ? number + " " : ""
  }${itemText1} کنید! برای ${itemText2} می‌توانید طرح فعلی خود را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقا دهید.`;
};

export const premiumFiniteUpgradePLanByAdminMessage = (
  number,
  itemText1,
  itemText2
) => {
  return `در طرح فعلی مالک شرکت، شما می‌توانید حداکثر ${
    number ? number + " " : ""
  }${itemText1} کنید! برای ${itemText2} می‌توانید طرح فعلی مالک را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقا دهید.`;
};

export const premiumFiniteUpgradePLanByNonOwnerNonAdminMessage = (
  number,
  itemText1,
  itemText2
) => {
  return `در طرح فعلی مالک شرکت، شما می‌توانید حداکثر ${
    number ? number + " " : ""
  }${itemText1} کنید! برای ${itemText2} می‌توانید از مالک یا ادمین شرکت بخواهید که طرح فعلی شرکت را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقا دهند.`;
};

export const premiumBuyPlanByOwnerMessage = itemText => {
  return `${itemText} و بسیاری امکانات دیگر در اشتراک حرفه‌ای تنخواه‌گردان در دسترس می‌باشد.`;
};

export const premiumBuyPlanByAdminMessage = itemText => {
  return `طرح فعلی مالک شرکت منقضی شده‌است.${itemText} و بسیاری امکانات دیگر در اشتراک حرفه‌ای تنخواه‌گردان در دسترس می‌باشد. برای استفاده از ویژگی‌های حرفه‌ای می‌توانید برای مالک شرکت طرح حرفه‌ای خریداری کنید.`;
};

export const premiumBuyPlanByNonOwnerNonAdminMessage = itemText => {
  return `از آنجایی که اعتبار اشتراک حرفه‌ای مالک شرکت به اتمام رسیده است لذا شما مجاز به ${itemText} نمی‌باشید.`;
};

export const premiumInFiniteUpgradePLanByOwnerMessage = itemText1 => {
  return `در طرح فعلی شما ${itemText1} امکان پذیر نمی‌باشد! برای ${itemText1} می‌توانید طرح فعلی خود را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقاء دهید.`;
};

export const premiumInFiniteUpgradePLanByAdminMessage = itemText1 => {
  return `در طرح فعلی مالک شرکت، ${itemText1} امکان پذیر نمی‌باشد! برای ${itemText1} می‌توانید طرح فعلی مالک را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقاء دهید.`;
};

export const premiumInFiniteUpgradePLanByNonOwnerNonAdminMessage = itemText1 => {
  return `در طرح فعلی مالک شرکت، شما ${itemText1} امکان پذیر نمی‌باشد! برای ${itemText1} می‌توانید از مالک یا ادمین شرکت بخواهید که طرح فعلی شرکت را به سایر طرح‌های اشتراک حرفه‌ای تنخواه‌گردان ارتقا دهند.`;
};

export const buyNewPremiumPlanByAdminMessage = (owner) =>{
  return `اعتبار نسخه حرفه‌ای مالک شرکت به پایان رسیده‌است، شما می‌توانید برای دسترسی مجدد به اطلاعات شرکت، نسخه حرفه‌ای تنخواه‌گردان را برای حساب کاربری ${owner} خریداری کنید.`
}

export const banAccessMessage = (project) =>{
  return `به دلیل پایان اعتبار اشتراک حرفه‌ای مالک شرکت ${project}، دسترسی شما مسدود شده‌است.`
}